const PreferenceKeys = {
    accessToken: 'dnk_admin_accessToken',
    accessTokenExpired: 'dnk_admin_accessToken_expired',
};

export default PreferenceKeys;